import React from 'react'

export default function Check(props) {
    return (
        <svg {...props} aria-label="Check mark" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.7308 20.11L0.800781 9.17L5.04078 4.93L11.7308 11.62L23.3608 0L27.6008 4.24L11.7308 20.11Z" fill="currentColor" />
        </svg>

    )
}
